
import { Grid2, Link, Box } from "@mui/material";
import doc_ic from "../../assets/document-ic.png";
import ai_ic from "../../assets/ai-note.webp";
import taskIcon from "../../assets/task-ic.png";
import meetingIcon from "../../assets/meeting-ic.png";
import projectIcon from "../../assets/projects-lc.png";
import workspace_ic from "../../assets/workspace.png";
import projects_ic from "../../assets/projects.png";
import meet_ic from "../../assets/meet.png";
import documents_ic from "../../assets/documents.png";
import { blue, amber } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

const Features = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: taskIcon,
      title: "Project Management",
      ft: "projects",
      description:
        "Transform your construction projects with our  project management system designed specifically for the construction industry. ",
      color: amber[600],
      backGround: "#F7FAFC",
      image: projects_ic
    },
    {
      icon: projectIcon,
      title: "Task and Plan Management",
      ft: "plansandtasks",
      description:
        "Take control of your construction schedule with our sophisticated task and plan management system. Our platform breaks down complex projects into manageable components.",
      color: blue[700],
      backGround: "#F7FAFC",
      image: workspace_ic
    },
    {
      icon: meetingIcon,
      title: "Meeting Scheduling",
      ft: "meetings",
      description:
        "Maximize the effectiveness of your project meetings with our specialized meeting management tools. From pre-planning to follow-up, our system ensures every meeting drives project progress forward.",
      color: amber[600],
      backGround: "#F7FAFC",
      image: meet_ic
    },
    {
      icon: doc_ic,
      title: "Document Management",
      ft: "documents",
      description:
        "Securely store and manage your project files in one place, enabling easy access for authorized users and efficient document collaboration. Version control included",
      color: blue[700],
      backGround: "#F7FAFC",
      image: documents_ic
    },
  ];

  return <section id="features">

    <div className="container-top space1">
      <h1 className="h1-48-600">
        <span>ConRa's</span> Key Features to Streamline Your Workflow
      </h1>
      <p className="ft-para">Discover how these cutting - edge features, with
        <img src={ai_ic} alt="ai note" />
        can transform your construction projects management.
      </p>
    </div>
    <div className="container-center">
    </div>
    <div className="grid-container space1">
      <Grid2 container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {features.map((feature, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 12, md: 6 }}
            className="grid-item"
            onClick={() => navigate("/feature", { state: { feat: feature.ft } })}
            style={{ backgroundColor: features[index].backGround, }}>
            <div className="feature-item">
              <div className="feature-top">
                <Box
                  sx={{
                    width: { xs: 24, sm: 30, md: 48, lg: 52 },
                    height: { xs: 24, sm: 30, md: 48, lg: 52 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    bgcolor: feature.color,
                    margin: "10px",
                    borderRadius: "20px",
                  }}
                >
                  <img src={feature.icon} alt="Feature icon" />

                </Box>
                <p className="feature-title">
                  {feature.title}
                </p>
              </div>

              <div className="feature-content">
                <p className="feature-text">
                  {feature.description}
                </p>
                <div className="arrow-icon"
                  // onClick={() => {
                  //   navigate("/feature", { state: { feat: feature.ft } });
                  //   window.scrollTo(0, 0);
                  // }}
                  onClick={() => navigate("/feature", { state: { feat: feature.ft } })}
                >
                  <span className="arrow">↗</span>
                </div>
              </div>

              <div className="feature-item-image">
                <img src={feature.image} alt={"company"} />
              </div>
            </div>
          </Grid2>
        ))}
      </Grid2>

      <div className="feature-item-footer">
        {/* <p>Still have questions? We're here to help!</p> */}
        <button onClick={() => navigate("/platform/features")} className="faq-button">Explore More Features </button>
      </div>
    </div>
  </section>;
};
export default Features;
